/*
  Sophestia — Wallpaper & Murals
  Panel hesaplayıcısı + ürün satın alma alanı.

  Fiyat, varyasyon ID'si, panel genişliği ve panel yükseklikleri burada SABİT DEĞİL.
  Hepsi Liquid tarafından gömülen Shopify verisinden okunur. Veri eksik veya
  tutarsızsa hesaplayıcı kapanır; varsayılan varyasyona sessizce düşülmez.
*/
(function () {
  'use strict';

  var CM_PER_IN = 2.54;
  var MAX_INPUT_IN = 1200; // 100 ft. Bunun üstü ölçüm desteği ister.

  /* Ölçüleri inç'in binde biri cinsinden tam sayıya çevirir.
     Birim dönüşümündeki kayan nokta artığının fazladan panel üretmesini engeller:
     116.84 cm -> 46.00000000000001 in -> 46000 -> tam 2 panel. */
  function milli(inches) {
    return Math.round(inches * 1000);
  }

  function toInches(value, unit) {
    return unit === 'cm' ? value / CM_PER_IN : value;
  }

  function fromInches(inches, unit) {
    return unit === 'cm' ? inches * CM_PER_IN : inches;
  }

  function trimNumber(n) {
    return String(Math.round(n * 100) / 100);
  }

  function formatLength(inches, unit) {
    return trimNumber(fromInches(inches, unit)) + (unit === 'cm' ? ' cm' : ' in');
  }

  function bothUnits(inches) {
    return trimNumber(inches) + ' in (' + trimNumber(inches * CM_PER_IN) + ' cm)';
  }

  /* Size secenegi ornegi: 1 Panel 23-inch W x 40-inch H */
  function parsePanelSize(value) {
    var m = /(\d+(?:\.\d+)?)\s*"?\s*W\s*x\s*(\d+(?:\.\d+)?)\s*"?\s*H/i.exec(value || '');
    if (!m) return null;
    var w = parseFloat(m[1]);
    var h = parseFloat(m[2]);
    if (!isFinite(w) || !isFinite(h) || w <= 0 || h <= 0) return null;
    return { widthIn: w, heightIn: h };
  }

  function parseMeasurement(raw) {
    if (raw == null) return { state: 'empty' };
    var text = String(raw).trim().replace(',', '.');
    if (text === '') return { state: 'empty' };
    if (!/^\d*\.?\d+$/.test(text)) return { state: 'not-a-number' };
    var n = parseFloat(text);
    if (!isFinite(n)) return { state: 'not-a-number' };
    if (n <= 0) return { state: 'not-positive' };
    return { state: 'ok', value: n };
  }

  /* ------------------------------------------------------------------ */

  function Buy(root) {
    this.root = root;
    this.data = null;
    this.mode = 'panel';
    this.quantities = { panel: '1', sample: '1' };
    this.unit = 'in';
    this.touched = { width: false, height: false };
    this.calc = null;
  }

  Buy.prototype.q = function (name) {
    return this.root.querySelector('[data-wp="' + name + '"]');
  };

  Buy.prototype.qa = function (name) {
    return Array.prototype.slice.call(this.root.querySelectorAll('[data-wp="' + name + '"]'));
  };

  Buy.prototype.init = function () {
    var script = this.root.querySelector('[data-wp="variant-data"]');
    if (!script) return this.fail('Product data is missing.');

    try {
      this.data = JSON.parse(script.textContent);
    } catch (e) {
      return this.fail('Product data could not be read.');
    }

    this.money = new Intl.NumberFormat(this.data.locale || 'en', {
      style: 'currency',
      currency: this.data.currency
    });

    var panels = [];
    var samples = [];
    var unparsed = 0;

    this.data.variants.forEach(function (v) {
      if (v.isSample) {
        samples.push(v);
        return;
      }
      var size = parsePanelSize(v.size);
      if (!size) {
        unparsed += 1;
        return;
      }
      v.widthIn = size.widthIn;
      v.heightIn = size.heightIn;
      panels.push(v);
    });

    this.panels = panels;
    this.samples = samples;

    /* Panel genişliği veriden doğrulanır, koda gömülmez. */
    var widths = panels
      .map(function (v) {
        return v.widthIn;
      })
      .filter(function (w, i, all) {
        return all.indexOf(w) === i;
      });

    this.panelWidthIn = widths.length === 1 ? widths[0] : null;
    this.calculatorUsable = this.panelWidthIn !== null && unparsed === 0 && panels.length > 0;

    this.heights = panels
      .map(function (v) {
        return v.heightIn;
      })
      .filter(function (h, i, all) {
        return all.indexOf(h) === i;
      })
      .sort(function (a, b) {
        return a - b;
      });

    if (!this.calculatorUsable) {
      var note = this.q('calc-unavailable');
      if (note) {
        note.hidden = false;
        note.textContent =
          widths.length > 1
            ? 'Panel widths differ between options, so the panel count cannot be calculated here.'
            : 'Some panel sizes could not be read, so the panel count cannot be calculated here.';
      }
      var calcBody = this.q('calc-body');
      if (calcBody) calcBody.hidden = true;
    }

    this.bind();
    this.render();
  };

  Buy.prototype.fail = function (message) {
    var box = this.q('form-error');
    if (box) {
      box.hidden = false;
      box.textContent = message;
    }
    var submit = this.q('submit');
    if (submit) submit.disabled = true;
  };

  Buy.prototype.bind = function () {
    var self = this;

    this.qa('mode').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var nextMode = input.value === 'sample' ? 'sample' : 'panel';
        if (nextMode === self.mode) return;
        var quantity = self.q('quantity');
        if (quantity) {
          self.quantities[self.mode] = quantity.value;
          quantity.value = self.quantities[nextMode];
        }
        self.mode = nextMode;
        self.render();
      });
    });

    this.qa('material').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) self.render();
      });
    });

    var height = this.q('height');
    if (height) {
      height.addEventListener('change', function () {
        self.render();
      });
    }

    this.qa('unit').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        self.switchUnit(input.value === 'cm' ? 'cm' : 'in');
      });
    });

    ['width', 'height'].forEach(function (field) {
      var el = self.q('wall-' + field);
      if (!el) return;
      el.addEventListener('input', function () {
        self.render();
      });
      el.addEventListener('blur', function () {
        self.touched[field] = true;
        self.render();
      });
    });

    var apply = this.q('apply');
    if (apply) {
      apply.addEventListener('click', function () {
        self.touched.width = true;
        self.touched.height = true;
        self.applyCalculation();
      });
    }

    var qty = this.q('quantity');
    if (qty) {
      qty.addEventListener('input', function () {
        self.render();
      });
    }

    var form = this.q('form');
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!self.currentVariant()) {
          event.preventDefault();
          self.fail('This combination is not available. Choose a different height or material.');
        }
      });
    }
  };

  /* Birim değişiminde fiziksel ölçü korunur. */
  Buy.prototype.switchUnit = function (next) {
    var self = this;
    if (next === this.unit) return;

    ['width', 'height'].forEach(function (field) {
      var el = self.q('wall-' + field);
      if (!el) return;
      var parsed = parseMeasurement(el.value);
      if (parsed.state !== 'ok') return;
      var inches = toInches(parsed.value, self.unit);
      el.value = trimNumber(fromInches(inches, next));
    });

    this.unit = next;
    this.qa('unit-label').forEach(function (el) {
      el.textContent = next === 'cm' ? 'cm' : 'in';
    });
    this.render();
  };

  Buy.prototype.selectedMaterial = function () {
    var checked = this.qa('material').filter(function (i) {
      return i.checked;
    })[0];
    return checked ? checked.value : null;
  };

  Buy.prototype.selectedHeight = function () {
    var el = this.q('height');
    if (!el || el.value === '') return null;
    var n = parseFloat(el.value);
    return isFinite(n) ? n : null;
  };

  Buy.prototype.currentVariant = function () {
    var material = this.selectedMaterial();
    if (!material) return null;

    if (this.mode === 'sample') {
      return (
        this.samples.filter(function (v) {
          return v.material === material;
        })[0] || null
      );
    }

    var height = this.selectedHeight();
    if (height === null) return null;
    return (
      this.panels.filter(function (v) {
        return v.material === material && milli(v.heightIn) === milli(height);
      })[0] || null
    );
  };

  Buy.prototype.readWall = function () {
    var out = {};
    var self = this;
    ['width', 'height'].forEach(function (field) {
      var el = self.q('wall-' + field);
      var parsed = el ? parseMeasurement(el.value) : { state: 'empty' };
      if (parsed.state === 'ok') {
        var inches = toInches(parsed.value, self.unit);
        if (milli(inches) > milli(MAX_INPUT_IN)) {
          parsed = { state: 'too-large' };
        } else {
          parsed.inches = inches;
        }
      }
      out[field] = parsed;
    });
    return out;
  };

  Buy.prototype.measurementError = function (parsed) {
    switch (parsed.state) {
      case 'not-a-number':
        return 'Enter a number, for example 100.';
      case 'not-positive':
        return 'Enter a measurement greater than zero.';
      case 'too-large':
        return 'That measurement is outside the range this calculator covers. Ask for measuring help.';
      default:
        return null;
    }
  };

  Buy.prototype.computeCalculation = function (wall) {
    if (!this.calculatorUsable) return null;
    if (wall.width.state !== 'ok' || wall.height.state !== 'ok') return null;

    var widthMilli = milli(wall.width.inches);
    var panelMilli = milli(this.panelWidthIn);
    var panels = Math.ceil(widthMilli / panelMilli);

    var wallHeightMilli = milli(wall.height.inches);
    var suggested = null;
    for (var i = 0; i < this.heights.length; i += 1) {
      if (milli(this.heights[i]) >= wallHeightMilli) {
        suggested = this.heights[i];
        break;
      }
    }

    return {
      panels: panels,
      widthIn: wall.width.inches,
      heightIn: wall.height.inches,
      suggestedHeightIn: suggested,
      exactFit: suggested !== null && milli(suggested) === wallHeightMilli,
      tooTall: suggested === null,
      coverageIn: (panels * panelMilli) / 1000
    };
  };

  Buy.prototype.applyCalculation = function () {
    this.render();
    if (!this.calc || this.calc.tooTall) return;

    if (this.calc.suggestedHeightIn !== null) {
      var select = this.q('height');
      if (select) {
        var target = String(this.calc.suggestedHeightIn);
        var match = Array.prototype.slice.call(select.options).filter(function (o) {
          return o.value === target;
        })[0];
        if (match) select.value = target;
      }
    }

    var qty = this.q('quantity');
    if (qty) qty.value = String(this.calc.panels);

    this.render();

    var applied = this.q('calc-applied');
    if (applied) {
      applied.hidden = false;
      applied.textContent =
        'Panel height and quantity updated to ' +
        (this.calc.suggestedHeightIn !== null
          ? trimNumber(this.calc.suggestedHeightIn) + ' in'
          : 'the selected height') +
        ', ' +
        this.calc.panels +
        (this.calc.panels === 1 ? ' panel.' : ' panels.');
    }
  };

  Buy.prototype.render = function () {
    var self = this;
    var isSample = this.mode === 'sample';

    /* Mod görünürlüğü */
    this.qa('panel-only').forEach(function (el) {
      el.hidden = isSample;
    });
    this.qa('sample-only').forEach(function (el) {
      el.hidden = !isSample;
    });

    /* Hesaplayıcı numune modunda gizlenir ve klavyeden de erişilemez olur */
    Array.prototype.slice
      .call(this.root.querySelectorAll('[data-wp-pcalc-field]'))
      .forEach(function (el) {
        el.disabled = isSample;
      });

    /* Ölçü hataları */
    var wall = this.readWall();
    ['width', 'height'].forEach(function (field) {
      var input = self.q('wall-' + field);
      var error = self.q('wall-' + field + '-error');
      if (!input || !error) return;
      var message = self.touched[field] && !isSample ? self.measurementError(wall[field]) : null;
      error.textContent = message || '';
      error.hidden = !message;
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
    });

    this.calc = isSample ? null : this.computeCalculation(wall);
    this.renderCalcResult();

    /* Varyasyon + fiyat */
    var variant = this.currentVariant();
    var qtyInput = this.q('quantity');
    var qtyParsed = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    var qty = isFinite(qtyParsed) && qtyParsed > 0 ? qtyParsed : 1;

    var unitLabel = this.q('unit-price-label');
    if (unitLabel) unitLabel.textContent = isSample ? 'per sample' : 'per panel';

    var priceEl = this.q('unit-price');
    var totalEl = this.q('total-price');
    var totalCount = this.q('total-count');
    var submit = this.q('submit');
    var idInput = this.q('variant-id');
    var formError = this.q('form-error');

    if (!variant) {
      if (priceEl) priceEl.textContent = '—';
      if (totalEl) totalEl.textContent = '—';
      if (idInput) idInput.value = '';
      if (submit) submit.disabled = true;
      if (formError) {
        formError.hidden = false;
        formError.textContent =
          'This combination is not available. Choose a different height or material.';
      }
      this.syncProperties(null);
      return;
    }

    if (formError) {
      formError.hidden = true;
      formError.textContent = '';
    }
    if (idInput) idInput.value = String(variant.id);
    if (submit) submit.disabled = !variant.available;

    if (priceEl) priceEl.textContent = this.money.format(variant.price / 100);
    if (totalEl) totalEl.textContent = this.money.format((variant.price * qty) / 100);
    if (totalCount) {
      totalCount.textContent =
        qty + ' × ' + (isSample ? (qty === 1 ? 'sample' : 'samples') : qty === 1 ? 'panel' : 'panels');
    }

    /* Adet, hesaplanan ihtiyacın altına inerse uyar */
    var shortfall = this.q('quantity-warning');
    if (shortfall) {
      var short = !isSample && this.calc && !this.calc.tooTall && qty < this.calc.panels;
      shortfall.hidden = !short;
      if (short) {
        shortfall.textContent =
          'The calculation needs ' +
          this.calc.panels +
          ' panels for a ' +
          formatLength(this.calc.widthIn, this.unit) +
          ' wall. You have ' +
          qty +
          '.';
      }
    }

    this.syncProperties(isSample ? null : this.calc);
  };

  Buy.prototype.renderCalcResult = function () {
    var out = this.q('calc-result');
    var support = this.q('calc-support');
    var applied = this.q('calc-applied');
    var apply = this.q('apply');

    if (applied) applied.hidden = true;

    if (!out) return;

    if (!this.calc) {
      out.hidden = true;
      out.innerHTML = '';
      if (support) support.hidden = true;
      if (apply) apply.disabled = true;
      return;
    }

    if (apply) apply.disabled = this.calc.tooTall;

    var lines = [];
    lines.push(
      '<p class="wp-pcalc__headline"><strong>' +
        this.calc.panels +
        (this.calc.panels === 1 ? ' panel' : ' panels') +
        '</strong> across a ' +
        formatLength(this.calc.widthIn, this.unit) +
        ' wall.</p>'
    );
    lines.push(
      '<p class="wp-pcalc__detail">' +
        this.calc.panels +
        (this.calc.panels === 1 ? ' panel covers ' : ' panels cover ') +
        trimNumber(this.calc.coverageIn) +
        ' in of wall width, at ' +
        trimNumber(this.panelWidthIn) +
        ' in of coverage each.</p>'
    );

    if (this.calc.tooTall) {
      lines.push(
        '<p class="wp-pcalc__detail">A ' +
          formatLength(this.calc.heightIn, this.unit) +
          ' wall is taller than the tallest panel offered (' +
          trimNumber(this.heights[this.heights.length - 1]) +
          ' in).</p>'
      );
    } else if (this.calc.exactFit) {
      lines.push(
        '<p class="wp-pcalc__detail">The ' +
          trimNumber(this.calc.suggestedHeightIn) +
          ' in panel matches the wall height exactly, so it leaves nothing to trim. Choosing the next height up gives you trim allowance.</p>'
      );
    } else {
      lines.push(
        '<p class="wp-pcalc__detail">Shortest panel that covers ' +
          formatLength(this.calc.heightIn, this.unit) +
          ': <strong>' +
          trimNumber(this.calc.suggestedHeightIn) +
          ' in</strong>.</p>'
      );
    }

    out.innerHTML = lines.join('');
    out.hidden = false;

    if (support) support.hidden = !this.calc.tooTall;
  };

  /* Ölçü bilgisi yalnızca wallpaper'a özel yeni anahtarlarla gider.
     Mevcut properties[Kişisel mesaj] alanına dokunulmaz. */
  Buy.prototype.syncProperties = function (calc) {
    var map = {
      'prop-wall-width': calc ? bothUnits(calc.widthIn) : '',
      'prop-wall-height': calc ? bothUnits(calc.heightIn) : '',
      'prop-panels': calc && !calc.tooTall ? String(calc.panels) : ''
    };

    Object.keys(map).forEach(
      function (key) {
        var el = this.q(key);
        if (!el) return;
        el.value = map[key];
        el.disabled = map[key] === '';
      }.bind(this)
    );
  };

  /* ------------------------------------------------------------------ */

  function initGallery(root) {
    var main = root.querySelector('[data-wp-gallery="main"]');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-wp-gallery="thumb"]'));

    thumbs.forEach(function (button) {
      button.addEventListener('click', function () {
        var src = button.getAttribute('data-src');
        var srcset = button.getAttribute('data-srcset');
        var alt = button.getAttribute('data-alt') || '';
        if (!src) return;
        main.setAttribute('src', src);
        if (srcset) main.setAttribute('srcset', srcset);
        main.setAttribute('alt', alt);
        thumbs.forEach(function (other) {
          other.setAttribute('aria-current', other === button ? 'true' : 'false');
        });
      });
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-wp-buy]')).forEach(function (root) {
      new Buy(root).init();
    });
    Array.prototype.slice
      .call(document.querySelectorAll('[data-wp-gallery="root"]'))
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
